import * as React from 'react';
import { TabsContext } from './SettingPopupTabs';

interface SettingPopupTabListProps {
  style?: React.CSSProperties;
}

const fundamentalStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
};

const SettingPopupTabList: React.SFC<SettingPopupTabListProps> = React.memo((props) => {
  const children = (
    props.children as React.ReactElement<any>[]
  ).map((elm, index) => {
    return React.cloneElement(elm, { index, key: `setting-popup-tab-${index}` });
  });

  return (
    <TabsContext.Consumer>{(state) => {
      const directionStyle: React.CSSProperties | null = state.vertical
        ? { flexDirection: 'column' }
        : null;

      return (
        <div style={{ ...fundamentalStyle, ...directionStyle, ...props.style }}>
          {children}
        </div>
      );
    }}</TabsContext.Consumer>
  );
});

export default SettingPopupTabList;
